import { RolePermissionNode } from './types';

export function filterPermissionTreeToSelection(
  nodes: RolePermissionNode[],
  selectedPermissionIds: readonly string[],
): RolePermissionNode[] {
  const selectedIds = new Set(selectedPermissionIds);

  function filterNodes(
    permissionNodes: RolePermissionNode[],
  ): RolePermissionNode[] {
    return permissionNodes.flatMap(node => {
      const visibleChildren = filterNodes(node.children ?? []);
      const isVisible =
        selectedIds.has(node.id) || visibleChildren.length > 0;
      if (!isVisible) return [];

      return [
        {
          ...node,
          children: visibleChildren.length > 0 ? visibleChildren : undefined,
        },
      ];
    });
  }

  return filterNodes(nodes);
}
